import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="grid-dark w-full bg-forest" data-id="element-119" data-mp="1o5q1qgnuw7zz">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-120" data-mp="221bvf151bfyq">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-dashed border-ember text-ember" data-id="element-121" data-mp="1x4uxxgby3p8z">
          <span className="font-mono text-4xl font-bold leading-none" data-id="element-122" data-mp="14fxtoh4kjsz8">7</span>
          <span className="text-xs font-bold uppercase tracking-widest" data-id="element-123" data-mp="14dtg17gvbflr">Days</span>
        </div>
        <p className="eyebrow mt-6 text-sky" data-id="element-124" data-mp="1j6dgu1gjpb01">Zero risk</p>
        <h2 id="guarantee-heading" className="rule-underline mt-3 font-display text-[34px] uppercase leading-tight text-paper sm:text-6xl" data-id="element-125" data-mp="1ed26hqciyc3d">
          Open everything. Run a call from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-paper/80" data-id="element-126" data-mp="ln2ayi3wybd6">
          Read the volumes, print the field cards and use the Split on your
          next no-ice call. If Ice Machine Diagnostic Pro doesn&apos;t change
          how you diagnose and close an ice machine call, email us within 7
          days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-127" data-mp="12pv5kog21jix">
          {chips.map(chip => <li key={chip} className="rounded-full border border-paper/25 px-4 py-2 text-[13px] text-paper/80" data-id="element-128" data-mp="61p5meu2vfaz">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}